import { render, staticRenderFns } from "./SimDesactivadoresForm.vue?vue&type=template&id=38a54892&scoped=true&"
import script from "./SimDesactivadoresForm.vue?vue&type=script&lang=ts&"
export * from "./SimDesactivadoresForm.vue?vue&type=script&lang=ts&"
import style0 from "./SimDesactivadoresForm.vue?vue&type=style&index=0&id=38a54892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a54892",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('38a54892', component.options)
    } else {
      api.reload('38a54892', component.options)
    }
    module.hot.accept("./SimDesactivadoresForm.vue?vue&type=template&id=38a54892&scoped=true&", function () {
      api.rerender('38a54892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/InventarioSim/SimDesactivadoresForm.vue"
export default component.exports